import { useParams, useLocation } from 'react-router-dom';

export default function ReviewRedirect() {
  const { id } = useParams<{ id: string }>();
  const { search } = useLocation();
  const target = `https://clareefai.com/review/${id ?? ''}${search}`;
  window.location.replace(target);
  return null;
}
